import React, { useState, useEffect } from "react";
import { Car, Scale } from "lucide-react";
import { data, Link, useParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import { db } from "../firebase"; // Import the Firestore instance
import { collection, doc, getDoc, getDocs, query, where } from "firebase/firestore"; // Import Firestore functions
import { useAuth } from "../context/AuthContext";
import Pagination, { ITEMS_PER_PAGE } from "../components/Pagination";
import CaseSearchFilter from "../components/CaseSearchFilter";
import PageHeader from "../components/PageHeader";

const DatewiseCases = () => {
    const { globalUser } = useAuth();
    const { id } = useParams();
    const [cardDetails, setCardDetails] = useState({});
    const [pendingCases, setPendingCases] = useState([]);
    const [selectedType, setSelectedType] = useState(true);
    const [filterPendingCases, setFilterPendingCases] = useState([]);
    const [filterDisposedCases, setFilterDisposedCases] = useState([]);
    const [disposedCases, setDisposedCases] = useState([]);
    const [ShowDisposedCases, setShowDisposedCases] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchFiltered, setSearchFiltered] = useState([]);

    // The list currently shown (pending or disposed), fed into the search/filter bar.
    const activeCases = selectedType ? filterPendingCases : filterDisposedCases;

    // Reset to page 1 whenever the filtered result set changes
    useEffect(() => {
        setCurrentPage(1);
    }, [searchFiltered]);
    console.log(id)

    useEffect(() => {

        const fetchCases = async () => {
            if (!globalUser) return; // Early return if user is not authenticated

            let caseList = [];
            const pendingCollection = collection(db, "pending"); // Reference to the "pending" collection
            const disposedCollection = collection(db, "disposed"); // Reference to the "disposed" collection

            // Create a query to filter pending cases by the current user's ID
            const pendingCasesQuery = query(
                pendingCollection,
                where("owner", "==", globalUser.uid)
            );
            const disposedCasesQuery = query(
                disposedCollection,
                where("owner", "==", globalUser.uid)
            );

            // Fetch documents from the pending collection
            const pendingSnapshot = await getDocs(pendingCasesQuery);
            const pendingList = [];
            pendingSnapshot.forEach((doc) => {
                const caseData = doc.data(); // Get the data from the document
                const newCase = {
                    id: doc.id, // Use the document ID
                    caseNumber: caseData.caseNo,
                    type: caseData.caseType,
                    petitionerName: caseData.petitionerName,
                    court: caseData.courtName,
                    status: caseData.status || "Status not available",
                    nextHearingDate: caseData.nextHearingDate || null,
                    caseFiledDate: caseData.caseFiledDate || null,
                    ...caseData
                };
                pendingList.push(newCase);
            });
            setPendingCases(pendingList);
            console.log(pendingList);

            // Fetch documents from the disposed collection
            const disposedSnapshot = await getDocs(disposedCasesQuery);
            const disposedList = [];
            disposedSnapshot.forEach((doc) => {
                const caseData = doc.data(); // Get the data from the document
                const newCase = {
                    id: doc.id, // Use the document ID
                    caseNumber: caseData.caseNo,
                    type: caseData.caseType,
                    petitionerName: caseData.petitionerName,
                    court: caseData.courtName,
                    status: caseData.status || "Status not available", // Fetching status field
                    nextHearingDate: caseData.nextHearingDate || null,
                    caseFiledDate: caseData.caseFiledDate || null,
                    ...caseData
                };
                disposedList.push(newCase);
            });

            setDisposedCases(disposedList)
            console.log(disposedList);

            const getUpcomingCases = (cases) => {
                const today = new Date();
                const sevenDaysLater = new Date();
                sevenDaysLater.setDate(today.getDate() + 7);

                const filteredList = cases.filter((c) => {
                    if (!c.nextHearingDate) return false;

                    const [day, month, year] = c.nextHearingDate.split('/');
                    const hearingDate = new Date(`${year}-${month}-${day}`); // convert to YYYY-MM-DD format

                    return hearingDate >= today && hearingDate <= sevenDaysLater;
                });

                return filteredList;
            };

            function normalizeDate(dateStr) {
                const [dd, mm, yyyy] = dateStr.split("/");
                return `${yyyy}-${mm}-${dd}`;
            }

            const getCasesForCaseFillingDate = (cases, date) => {
                const filteredCases = cases.filter(caseObj => {
                    if (!caseObj.caseFiledDate) return false; // Skip if null or empty
                    const normalizedCaseDate = normalizeDate(caseObj.caseFiledDate);
                    return normalizedCaseDate === date;
                });

                return filteredCases;

            }

            const getCasesWithNextHearing = (cases) => {
                const filteredCases = cases.filter((item) => item.nextHearingDate !== null);
                return filteredCases;
            }
            // Getting Card
            const docRef = doc(db, "metricCard", id);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                const data = docSnap.data()
                console.log(data)
                setCardDetails(data);
                if (data.field === "hearingInSevenDays") {
                    setFilterPendingCases(getUpcomingCases(pendingList))
                    setFilterDisposedCases(getUpcomingCases(disposedList));
                }

                else if (data.field === "created on") {
                    console.log(pendingList)
                    setFilterPendingCases(getCasesForCaseFillingDate(pendingList, data.date));
                    setFilterDisposedCases(getCasesForCaseFillingDate(disposedList, data.date))
                }

                else if (data.field === "hasNextDate") {
                    setFilterPendingCases(getCasesWithNextHearing(pendingList));
                    setFilterDisposedCases(getCasesWithNextHearing(disposedList));
                }

            }
            else {
                console.log("card not found")
            }




        };

        // getMetricCard()
        fetchCases();
        // if (selectedType) {
        //     const list = getUpcomingCases(pendingCases);
        //     console.log(pendingCases)
        //     setFilterCases(list);
        // }
        // else {
        //     const list = getUpcomingCases(disposedCases);
        //     setFilterCases(list);
        // }






    }, [globalUser]);

    if (cardDetails.field === "created On") {
        setShowDisposedCases(true);
    }






    return (


        <div className="min-h-screen bg-[#0c0a29] text-white relative">
            <Navbar />
            <div className="background-circle circle-3 z-0"></div>
            <div className="background-circle circle-4 z-0"></div>

            <main className="px-4 sm:px-6 md:px-8 py-8">
                <PageHeader
                    title="Pending Cases"
                    subtitle="Cases grouped by hearing date"
                    actions={
                        activeCases.length > 0 && (
                            <CaseSearchFilter
                                cases={activeCases}
                                onFilteredChange={setSearchFiltered}
                                className="md:mr-12 w-40 sm:w-56 md:w-72"
                            />
                        )
                    }
                />

                <div className="flex flex-col items-center">
                    <div className="flex items-center justify-center gap-6 mb-10 mt-1 w-11/12 md:w-1/2">
                        <div
                            className={`${selectedType ? "bg-yellow-300 bg-opacity-60 " : "bg-white bg-opacity-80"} rounded-lg p-6 hover:bg-opacity-80 transition cursor-pointer text-center w-96`}
                            onClick={() => { setSelectedType(true) }}
                        >
                            <h3 className="text-black text-2xl mb-2">{cardDetails.field}</h3>
                            <p className="text-black text-3xl font-bold">
                                {filterPendingCases.length}
                            </p>
                        </div>

                        {ShowDisposedCases && <div

                            className={`${!selectedType ? "bg-yellow-300 bg-opacity-60 " : "bg-white bg-opacity-60"} rounded-lg p-6 hover:bg-opacity-80 transition cursor-pointer text-center w-96`}
                            onClick={() => { setSelectedType(false) }}
                        >
                            <h3 className="text-2xl mb-2 text-black">DISPOSED CASES</h3>
                            <p className="text-3xl font-bold text-black">
                                {filterDisposedCases.length}
                            </p>
                        </div>}


                    </div>
                </div>

                {/* Case Cards */}
                <div className="md:px-12">
                    <div className="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {searchFiltered.length > 0 ? searchFiltered.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE).map((caseItem) => (
                            <Link
                                key={caseItem.id}
                                to={`/portal/case/${caseItem.id}`}
                                className="bg-[#1e1b4b] rounded-lg p-4 hover:bg-[#2d2a5a] transition-colors duration-200"
                            >
                                <div className="flex">
                                    <div className="mr-4 flex items-center">
                                        <div className="w-16 h-16 flex items-center justify-center">
                                            <Scale size={48} color="#FFD700" strokeWidth={1.5} />
                                        </div>
                                    </div>
                                    <div>
                                        <p className="text-sm text-gray-400">
                                            Case Number: {caseItem.caseNumber}
                                        </p>
                                        <h3 className="text-xl font-bold">{caseItem.type}</h3>
                                        <p>Party Name: {caseItem.petitionerName}</p>
                                        <p>Court: {caseItem.court}</p>
                                        <p>Status: {caseItem.status}</p>{" "}
                                        {/* Displaying case status */}
                                    </div>
                                </div>
                            </Link>
                        )) : (
                            <div className="col-span-full text-center text-gray-400 py-8">
                                {activeCases.length > 0
                                    ? "No cases match your current filters."
                                    : "No cases found."}
                            </div>
                        )}
                        { }
                    </div>
                    <Pagination
                        currentPage={currentPage}
                        totalItems={searchFiltered.length}
                        onPageChange={(page) => {
                            setCurrentPage(page);
                            window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                    />
                </div>
            </main>
        </div>
    )

}

export default DatewiseCases;